// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__2_jOJ","content":"Page_content__h99-o","scrollingDisabled":"Page_scrollingDisabled__2nnuV"};